module.exports = __webpack_public_path__ + "static/media/calling-all-reactive-agents-3.a01e43a6.jpg";